import { createContext } from 'react'

export const UserContext = createContext()
export const createUserContext = (user) => {
  return { isLoggedIn: !!user, user }
}
